import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material"

const CancelDialog = ({ onClose, onConfirm, action, bookTitle }) => {
  return (
    <Dialog open onClose={onClose}>
      <DialogTitle>{action === "buy" ? "Kauf" : "Verkauf"} abbrechen</DialogTitle>

      <DialogContent>
        <Typography>
          Möchtest du den {action === "buy" ? "Kauf" : "Verkauf"} des Buches <b>{bookTitle}</b> wirklich abbrechen?
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Nein
        </Button>

        <Button onClick={onConfirm} variant="contained" color="primary">
          Ja
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CancelDialog
